import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import { mockFeedbacks } from '../../components/Data/MockData';

function FeedbackEdit() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        ticket_number: '',
        customer_name: '',
        contact_number: '',
        email: '',
        feedback_text: '',
        driver_rating: 5,
        overall_rating: 5,        
        exit_location_id: '',
        driver_id: ''
    });

    useEffect(() => {
        fetchFeedback();
    }, [id]);

    const fetchFeedback = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/feedbacks/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading feedback');
            navigate('/accounts/feedback-list');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

     const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.put(`accounts/feedbacks/${id}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Feedback updated successfully');
            navigate('/accounts/feedback-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error updating feedback');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Edit Feedback' />
                <Card>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <Row className="g-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Ticket Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ticket_number"
                                            value={formData.ticket_number}
                                            onChange={handleInputChange}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Customer Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="customer_name"
                                            value={formData.customer_name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Contact Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="contact_number"
                                            value={formData.contact_number}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Driver Rating (1-5)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="driver_rating"
                                            value={formData.driver_rating}
                                            onChange={handleInputChange}
                                            min="1"
                                            max="5"
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Overall Rating (1-5)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="overall_rating"
                                            value={formData.overall_rating}
                                            onChange={handleInputChange}
                                            min="1"
                                            max="5"
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Feedback Text</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            name="feedback_text"
                                            value={formData.feedback_text}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Button type="submit" variant="primary">
                                        Update Feedback
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default FeedbackEdit;